
      // Import Supabase client
      import { createClient } from 'https://esm.sh/@supabase/supabase-js@2';
      
      // Function to check if we're on an incident page
      function isIncidentPage() {
        return window.location.pathname.includes('/incident/');
      }
      
      // Only run on incident pages
      if (isIncidentPage()) {
        // Initialize Supabase client
        const supabaseUrl = 'https://uhzonjkbxtplengyswsb.supabase.co';
        const supabaseAnonKey = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InVoem9uamtieHRwbGVuZ3lzd3NiIiwicm9sZSI6ImFub24iLCJpYXQiOjE3MDY0NzA5NzcsImV4cCI6MjAyMjA0Njk3N30.Nh83ebqzf1iGHTaGzK-qjl9K08xdwbcpYGmD-6ZUjNY';
        const supabase = createClient(supabaseUrl, supabaseAnonKey);
        
        // Get the incident slug from the URL
        const slug = window.location.pathname.split('/incident/')[1];
        
        // Fetch incident data
        async function updateMetaTags() {
          try {
            // Fetch incident by slug
            const { data: incident, error } = await supabase
              .from('incidents')
              .select(`
                *,
                incident_media (
                  id,
                  type,
                  url
                )
              `)
              .eq('slug', slug)
              .single();
            
            if (error || !incident) {
              console.error('Error fetching incident:', error);
              return;
            }
            
            // Determine image URL
            let imageUrl;
            if (incident.incident_media && incident.incident_media.length > 0) {
              imageUrl = incident.incident_media[0].url;
            } else {
              // Fall back to incident type image
              const incidentType = incident.type.toLowerCase().replace(/\s+/g, '_');
              imageUrl = `${window.location.origin}/incident-types/${incidentType}.webp`;
            }
            
            // Create description
            const description = incident.description || 
              `${incident.type} incident reported in ${incident.location_zone}. View details on RapoKrim.`;
            
            // Update meta tags
            document.title = `${incident.type} Incident - RapoKrim`;
            document.querySelector('meta[name="description"]').setAttribute('content', description);
            
            // Update Open Graph meta tags
            document.querySelector('meta[property="og:type"]').setAttribute('content', 'article');
            document.querySelector('meta[property="og:url"]').setAttribute('content', window.location.href);
            document.querySelector('meta[property="og:title"]').setAttribute('content', `${incident.type} Incident - RapoKrim`);
            document.querySelector('meta[property="og:description"]').setAttribute('content', description);
            document.querySelector('meta[property="og:image"]').setAttribute('content', imageUrl);
            
            // Update Twitter meta tags
            document.querySelector('meta[name="twitter:card"]').setAttribute('content', 'summary_large_image');
            document.querySelector('meta[name="twitter:title"]').setAttribute('content', `${incident.type} Incident - RapoKrim`);
            document.querySelector('meta[name="twitter:description"]').setAttribute('content', description);
            document.querySelector('meta[name="twitter:image"]').setAttribute('content', imageUrl);
            document.querySelector('meta[name="twitter:image:alt"]').setAttribute('content', `${incident.type} incident in ${incident.location_zone}`);
            
            console.log('Meta tags updated for incident:', incident.type);
          } catch (error) {
            console.error('Error updating meta tags:', error);
          }
        }
        
        // Run the update function
        updateMetaTags();
      }
    